import { DEFAULT_SORT_ITEMS } from '../../../shared/ui/select';
import { IconMap } from '../../../shared/sprite';

export const noTemplatesMessageDictionary = {
  personal: 'Tailor templates to suit your specific needs.',
  team: 'Build templates that propel your team to success.',
  drafts: 'Create templates to streamline your workflow.',
};

export const SORT_ITEMS = {
  lastCreated: DEFAULT_SORT_ITEMS.lastCreated,
  mostPopular: { glyph: IconMap.Star, label: 'Most popular' },
  name: DEFAULT_SORT_ITEMS.name,
} as const;

export enum TemplatesTab {
  TEAM = 'team',
  PERSONAL = 'personal',
  DRAFTS = 'drafts',
}
